<template>
<div class="row">
	<div class="input-group input-group-sm mb-3 col-md-3 col-sm-12" v-for="(parameter, index) in parameters" :key="index">
		<div class="input-group-prepend">
			<span class="input-group-text" id="inputGroup-sizing-sm" v-text="parameter.name"></span>
		</div>
		<input type="text" class="form-control" v-model="parameter.default">
	</div>
</div>
</template>

<script>
	import { mapState } from 'vuex';

	export default {
		computed: {
			...mapState('reports', {
                parameters: 'parameters',
			})
		},
	}
</script>

<style scoped>
</style>
